import type { Theme, ThemeId } from './theme.types';

export const DEFAULT_THEME_ID: ThemeId = 'gold_beige';

export const THEMES: Record<ThemeId, Theme> = {
  gold_beige: {
    id: 'gold_beige',
    name: 'Золотой беж',
    description: 'Роскошный, элегантный, премиальный',
    colors: {
      background: '#FFFFFF',
      surface: '#F8F5EE',
      primary: '#D4AF37',
      secondary: '#BFAE8A',
      text: '#6B5E3D',
      heading: '#2E2E2E',
      decoration: '#F9E7D9',
    },
  },
  powder_rose: {
    id: 'powder_rose',
    name: 'Пудрово-розовый',
    description: 'Романтичный, нежный, элегантный',
    colors: {
      background: '#FFFFFF',
      surface: '#FFF5F5',
      primary: '#F7C8D8',
      secondary: '#D8A7B7',
      text: '#6B4F5B',
      heading: '#3A2F36',
      decoration: '#FCE7EF',
    },
  },
  lavender: {
    id: 'lavender',
    name: 'Лавандовый',
    description: 'Стильный, спокойный, современный',
    colors: {
      background: '#FFFFFF',
      surface: '#F5F3FF',
      primary: '#A78BFA',
      secondary: '#C9B8F7',
      text: '#5B4B8A',
      heading: '#2E1F47',
      decoration: '#EDE7FF',
    },
  },
  emerald: {
    id: 'emerald',
    name: 'Изумрудный',
    description: 'Благородный, свежий, современный',
    colors: {
      background: '#FFFFFF',
      surface: '#F7FAF9',
      primary: '#10B981',
      secondary: '#6EE7B7',
      text: '#064E3B',
      heading: '#022C22',
      decoration: '#D1FAE5',
    },
  },
  blue_graphite: {
    id: 'blue_graphite',
    name: 'Синий графит',
    description: 'Строгий, стильный, премиальный',
    colors: {
      background: '#FFFFFF',
      surface: '#F1F5F9',
      primary: '#3B82F6',
      secondary: '#93C5FD',
      text: '#1E3A8A',
      heading: '#0F172A',
      decoration: '#DBEAFE',
    },
  },
  warm_peach: {
    id: 'warm_peach',
    name: 'Тёплый персик',
    description: 'Уютный, лёгкий, романтичный',
    colors: {
      background: '#FFFFFF',
      surface: '#FFF7F3',
      primary: '#FFB4A2',
      secondary: '#FFD6C2',
      text: '#8B5E3C',
      heading: '#5C3A2E',
      decoration: '#FFECE3',
    },
  },
};

export const THEME_IDS = Object.keys(THEMES) as ThemeId[];

export function isThemeId(value: unknown): value is ThemeId {
  return typeof value === 'string' && value in THEMES;
}
